module.exports = __webpack_public_path__ + "media/team/maissane-11a5f073.png";